import { logger } from '@shared-services/log-service';

export const API_URL = 'https://api.cal.com/v2';

async function fetchCalCom(url: string, options: object) {
    const res = await fetch(API_URL + url, options);
    const jsonRes = await res.json();
    return jsonRes.data || jsonRes;
}

export async function cancelBooking(
    bookingUid: string,
    cancellationReason?: string
) {
    const url = `/bookings/${bookingUid}/cancel`;
    try {
        const res = await fetchCalCom(url, {
            method: 'POST',
            body: JSON.stringify({ cancellationReason }),
        });
        if (res.error) {
            throw new Error(res.error?.message || res.error);
        }
        return res;
    } catch (e) {
        logger.error({
            message: `Failed to cancel booking with UID: ${bookingUid}`,
            errorMessage: e?.toString(),
            url,
            tags: ['cal-booking', 'cancel-booking'],
        });
    }
}

export async function getBooking(bookingUid: string) {
    const url = `/bookings/${bookingUid}`;
    return await fetchCalCom(url, {
        method: 'GET',
    });
}
